import { UTSLocale } from "@smile2impress/attraction-constants";

import { mapItemsWithIcon } from "./mapItemsWithIcon";
import { mapLink } from "./mapLink";

export function mapTwoColumnListItems<
    T extends { icon?: { type?: string }; link?: { href?: string } }
>(items: T[], locale: UTSLocale) {
    return mapItemsWithIcon(items).map((item) => ({
        ...item,
        link: mapLink(item.link?.href, locale),
    }));
}
